var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"border-top":"1px solid #eee"}},[_c('div',{},[_c('el-form',{ref:"objectForm",attrs:{"model":_vm.objectForm,"rules":_vm.formRules,"label-width":"100px"}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_vm._v(" 1 ")])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }